import { render } from "./MiniProductCard.vue?vue&type=template&id=9f9ba558"
import script from "./MiniProductCard.vue?vue&type=script&lang=js"
export * from "./MiniProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__